import { action, makeObservable, observable } from 'mobx';
import { Message, StoreNode, StoreNodeProps } from '../../store';
import { Store } from '../../store/store';
import { WindowState } from '../overlays';

export type RemoveAccessOpenParams = {
  onSubmit: () => void
  modalMessage?: string,
  title?: string
}

export class CloseWindowConfirmationModalState
  extends StoreNode {

  readonly nodeType = 'CloseWindowConfirmationModal';

  constructor(store: Store, props?: StoreNodeProps) {
    super(store, props);
    makeObservable(this, {
      isLoading: observable,
      onSubmit: observable,
      modalMessage: observable,
      title: observable,
      submit: action,
      open: action,
      close: action,
    });
    this.window.listen(
      this.windowListener);
  }
  isLoading: boolean = false;
  onSubmit: (() => void) | null = null;
  modalMessage: string | null = null;
  title: string | null = null;

  private windowListener = (msg: Message<WindowState>) => {
    switch (msg.type) {
      case 'close':
        // case 'outsideClick':
        if (this.isLoading)
          return;
        this.close('close');
        break;
    }
  }
  readonly window = new WindowState(this.store);

  async submit() {
    this.close();
    if (this.onSubmit)
      this.onSubmit();
  }

  open(params: RemoveAccessOpenParams) {
    this.dispatch('Overlays', 'openWindow', { name: 'CloseWindowConfirmationModal' });
    this.onSubmit = params.onSubmit;
    this.modalMessage = params.modalMessage || null;
  }

  close(msg?: string) {
    this.dispatch('Overlays', 'closeWindow');
    if (msg) this.emit(msg);
  }
}